module.exports = __webpack_public_path__ + "static/1-c6309c6a421bdfab81448905f1dcc6da.png";